const initialState = {}

export const nominalPaymentReducer = (state = initialState, actions) => {
    if (actions.type === 'SET_NOMINAL_PAYMENT') {
        return {
            ...state,
            nominalPayment: actions.nominalPayment
        }
    }
    return state
}